import { useContext } from "react";
import { CupixThemeContext } from "../context/cupixTheme";

import LogoCupix from "../assets/images/logo-cupix.png";
import LogoCupixvista from "../assets/images/logo-cupixvista.svg";
import LogoCupixworks from "../assets/images/logo-cupixworks.svg";

const logoMap: { [key: string]: string } = {
  'cupixvista': LogoCupixvista,
  'cupixworks': LogoCupixworks,
  'default': LogoCupix
};

export const CPLogo = () => {
  const cupixTheme = useContext(CupixThemeContext);
  const logo = logoMap[cupixTheme] || logoMap['default'];

  return (
    <img src={logo} alt={cupixTheme} className="mb-4" style={{ height: 28 }}/>
  );
};